// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customDateHourSelectorWrapper_FXTjx {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	width: 100%;
	gap: 10px;
}
.customDateHourSelectorDate_Jofg9 {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	font-size: 16px;
	color: var(--_3c3a3a-color);
	font-weight: 500;
	border: 1px solid transparent;
	position: relative;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	transition: border 0.2s ease-in-out;
	&:hover {
		border-bottom: 1px solid var(--text-color-secondary);
	}
}
.customDateHourSelectorHourStart_WZXzr {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	margin-left: 22px;
	color: var(--_3c3a3a-color);
	font-weight: 500;
	border: 1px solid transparent;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	position: relative;
	transition: border 0.2s ease-in-out;
	&:hover {
		border-bottom: 1px solid var(--text-color-secondary);
	}
}
.customDateHourSelectorHourEnd_TztMk {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	color: var(--_3c3a3a-color);
	font-weight: 500;
	border: 1px solid transparent;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	position: relative;
	transition: border 0.2s ease-in-out;
	&:hover {
		border-bottom: 1px solid var(--text-color-secondary);
	}
}

.dropdown_o8aK9 {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	max-height: 200px;
	width: 150px;
	overflow-y: auto;
	background-color: var(--f5-background);
	border-radius: 4px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	z-index: 1000;
}

.option_uwZq0 {
	padding: 8px;
	cursor: pointer;
	color: var(--_3c3a3a-color);
	transition: background-color 0.15s;
	font-size: 13px;
	font-weight: 500;
}

.option_uwZq0:hover {
	background-color: var(--_16c0982e-background);
}

.selected_nXW25 {
	background-color: var(--_16c0982e-background);
}

.hovered_mwZT2 {
	background-color: var(--_16c0982e-background);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CustomDateHourSelector.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,WAAW;CACX,SAAS;AACV;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,eAAe;CACf,2BAA2B;CAC3B,gBAAgB;CAChB,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,mCAAmC;CACnC;EACC,oDAAoD;CACrD;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,gBAAgB;CAChB,6BAA6B;CAC7B,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB,mCAAmC;CACnC;EACC,oDAAoD;CACrD;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,2BAA2B;CAC3B,gBAAgB;CAChB,6BAA6B;CAC7B,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,kBAAkB;CAClB,mCAAmC;CACnC;EACC,oDAAoD;CACrD;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,iBAAiB;CACjB,YAAY;CACZ,gBAAgB;CAChB,sCAAsC;CACtC,kBAAkB;CAClB,wCAAwC;CACxC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,2BAA2B;CAC3B,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,6CAA6C;AAC9C","sourcesContent":[".customDateHourSelectorWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\twidth: 100%;\n\tgap: 10px;\n}\n.customDateHourSelectorDate {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tfont-size: 16px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-weight: 500;\n\tborder: 1px solid transparent;\n\tposition: relative;\n\tcursor: pointer;\n\tuser-select: none;\n\ttransition: border 0.2s ease-in-out;\n\t&:hover {\n\t\tborder-bottom: 1px solid var(--text-color-secondary);\n\t}\n}\n.customDateHourSelectorHourStart {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 16px;\n\tmargin-left: 22px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-weight: 500;\n\tborder: 1px solid transparent;\n\tcursor: pointer;\n\tuser-select: none;\n\tposition: relative;\n\ttransition: border 0.2s ease-in-out;\n\t&:hover {\n\t\tborder-bottom: 1px solid var(--text-color-secondary);\n\t}\n}\n.customDateHourSelectorHourEnd {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 16px;\n\tcolor: var(--_3c3a3a-color);\n\tfont-weight: 500;\n\tborder: 1px solid transparent;\n\tcursor: pointer;\n\tuser-select: none;\n\tposition: relative;\n\ttransition: border 0.2s ease-in-out;\n\t&:hover {\n\t\tborder-bottom: 1px solid var(--text-color-secondary);\n\t}\n}\n\n.dropdown {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tright: 0;\n\tmax-height: 200px;\n\twidth: 150px;\n\toverflow-y: auto;\n\tbackground-color: var(--f5-background);\n\tborder-radius: 4px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tz-index: 1000;\n}\n\n.option {\n\tpadding: 8px;\n\tcursor: pointer;\n\tcolor: var(--_3c3a3a-color);\n\ttransition: background-color 0.15s;\n\tfont-size: 13px;\n\tfont-weight: 500;\n}\n\n.option:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.selected {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.hovered {\n\tbackground-color: var(--_16c0982e-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customDateHourSelectorWrapper": `customDateHourSelectorWrapper_FXTjx`,
	"customDateHourSelectorDate": `customDateHourSelectorDate_Jofg9`,
	"customDateHourSelectorHourStart": `customDateHourSelectorHourStart_WZXzr`,
	"customDateHourSelectorHourEnd": `customDateHourSelectorHourEnd_TztMk`,
	"dropdown": `dropdown_o8aK9`,
	"option": `option_uwZq0`,
	"selected": `selected_nXW25`,
	"hovered": `hovered_mwZT2`
};
export default ___CSS_LOADER_EXPORT___;
